import { useEffect, useRef } from "react";
import { api } from "@/api/client";
import { useStore } from "@/state/store";

export function usePhasePolling(enabled = true, intervalMs = 3000) {
  const { state, dispatch } = useStore();
  const token = state.auth.token;
  const cancelled = useRef(false);

  useEffect(() => {
    cancelled.current = false;
    if (!enabled || !token) return;

    let timer: ReturnType<typeof setTimeout> | null = null;

    const tick = async () => {
      if (cancelled.current || document.hidden) {
        timer = setTimeout(tick, intervalMs);
        return;
      }
      try {
        const phase = await api.phase.get(token);
        if (!cancelled.current) dispatch({ type: "phase/set", phase });
      } catch {
        /* swallow transient errors */
      }
      if (!cancelled.current) timer = setTimeout(tick, intervalMs);
    };

    tick();

    return () => {
      cancelled.current = true;
      if (timer) clearTimeout(timer);
    };
  }, [enabled, token, intervalMs, dispatch]);
}
